<app-navbar></app-navbar>
    <div class="container my-4">
        <div class="row">
            <div class="col-lg-8">
                <div class="inter">
                    <h1 class="fw-semibold display-2 mb-5">How can we <span class="text-secondary">help</span> you today.</h1>
                    <p class="fs-2 inter fw-medium">Our dedicated <span class="text-secondary">customer support</span> team is just <br> a message or call away.</p>
                </div>
                <div class="row mt-5">
                    <div class="col-lg-12">
                        <div class="google-map">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3860.0009149025254!2d121.01045474859235!3d14.655889440458031!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397b68d298bc4fb%3A0xd37c286ae3a5d8c6!2sBewell%20Nutraceuticals%20Corporation!5e0!3m2!1sen!2sph!4v1785733860799!5m2!1sen!2sph" width="100%" height="475" frameborder="0" class="position-relative google-map-frame p-0 m-0 rounded" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <form [formGroup]="form" (ngSubmit)="send()">
                    <div class="inter fs-7 border border-cstm rounded-2 p-4">
                        <h5 class="p-0 mt-0 mb-3 fw-semibold">Send us a message</h5>
                        <div class="fw-medium lh-lg">Got any questions about our product or other query? We're here to help.</div>
                        <div class="mt-3 sent-msg">
                            @if(isSent()) {
                                <div class="alert alert-success inter mb-0" role="alert">Thank you, we have received your message.</div>
                            }
                        </div>
                        <div class="row mb-4 mt-4">
                            <div class="col-lg-6">
                                <div class="form-group" [ngClass]="{'has-error': form.controls.firstname.touched && form.controls.firstname.invalid}">
                                    <label for="firstname" class="fs-7 pb-1 fw-medium">Firstname</label>
                                    <input type="text" id="firstname" class="form-control" spellcheck="false" placeholder="Firstname" autocomplete="false" formControlName="firstname">
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group" [ngClass]="{'has-error': form.controls.lastname.touched && form.controls.lastname.invalid}">
                                    <label for="lastname" class="fs-7 pb-1 fw-medium">Lastname</label>
                                    <input type="text" id="lastname" class="form-control" spellcheck="false" placeholder="Lastname" autocomplete="false" formControlName="lastname">
                                </div>
                            </div>
                        </div>
                        <div class="row mb-4 mt-4">
                            <div class="col-lg-6">
                                <div class="form-group" [ngClass]="{'has-error': form.controls.email.touched && form.controls.email.invalid}">
                                    <label for="email" class="fs-7 pb-1 fw-medium">Email</label>
                                    <input type="text" id="email" class="form-control" spellcheck="false" placeholder="Email" autocomplete="false" formControlName="email">
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group" [ngClass]="{'has-error': form.controls.phone.touched && form.controls.phone.invalid}">
                                    <label for="phone" class="fs-7 pb-1 fw-medium">Phone No</label>
                                    <input type="text" id="phone" class="form-control" spellcheck="false" placeholder="Phone No." autocomplete="false" formControlName="phone">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="form-group mb-3">
                                    <label for="subject" class="fs-7 pb-1 fw-medium">Subject</label>
                                    <select id="subject" class="form-select form-control shadow-none inter" placeholder="Select Subject" formControlName="subject">
                                        @for (obj of subjects; track obj) {
                                            <option [value]="obj" [disabled]="obj == 'select-subject'">{{capitalize(obj)}}</option>
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-4">
                            <div class="form-group" [ngClass]="{'has-error': form.controls.message.touched && form.controls.message.invalid}">
                                <label for="message" class="fs-7 pb-1 fw-medium d-block">Message 
                                    @if(form.value.message?.length! > 0){
                                        <span class="float-end text-muted">{{form.value.message?.length}}/300</span>
                                    }
                                </label>
                                <textarea id="message" rows="5" class="form-control" spellcheck="false" placeholder="Message.." autocomplete="false" formControlName="message"></textarea>
                            </div>
                        </div>
                        <div class="mb-4">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="agree" (change)="agree($event)" formControlName="agree">
                                <label class="form-check-label" for="agree">
                                    I agree with the privacy statement.
                                </label>
                            </div>
                        </div>
                        <div class="mb-3">
                            <ngx-turnstile formControlName="captchaToken" [siteKey]='siteKey' (resolved)='captchaResponse($event)' theme="auto" [tabIndex]="0" [size]="'flexible'" [retry]="'auto'" [refreshExpired]="'auto'"></ngx-turnstile>
                        </div>
                        <div class="d-grid gap-2">
                            <button type="submit" class="btn btn-block btn-dark rounded-2 fs-7 py-2" [disabled]="form.invalid || form.value.subject == 'select-subject' || isLoading()">
                                {{isLoading() ? 'Sending..': 'Send Message'}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
<app-footer></app-footer>